import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const BatelcoBahrainIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}&inviteReferral=${this.getInviteReferral || ''}`;
      };
    },
  },
};

export default BatelcoBahrainIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/batelcoBahrainIntegration.js